<template>
    <v-app v-resize="onResize">
        <router-view />
        <app-modal />
    </v-app>
</template>

<script>
import VueRouter from 'vue-router';
import * as Sentry from '@sentry/vue';
import { loadScript } from "vue-plugin-load-script";


const { isNavigationFailure, NavigationFailureType } = VueRouter;

export default {
    mounted() {
        // Load Churnzero
        loadScript("https://beereaders.us1app.churnzero.net/churnzero.js")
        .then(() => {
            // Script is loaded, do something
            window.ChurnZero = window.ChurnZero || []
        })
        .catch(() => {
            // Failed to fetch script
            console.log('Unable to load ChurnZero')
        });
    },
    methods: {
        async onResize() {
            if (this.validateIsMobile() && this.$router.history.current.name !== 'Store banner') {
                await this.$router.push('/to-store').catch((error) => {
                    // Catched error caused by slow network and multiple resizing
                    if (!isNavigationFailure(error, NavigationFailureType.cancelled)) {
                        Sentry.captureException(error)
                    }
                })
            }
        },
        validateIsMobile() {
            return window.innerWidth < 600
        },
    },
}
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
